import React, { Component } from 'react'
import { connect } from 'react-redux'
import { saveEvent } from '../actions/events'

import DateTimePicker from './micro/DateTime'

class EventForm extends Component {
  state = {
    name: '',
    description: '',
    location: '',
    datetime: '',
    url: '',
    image: null,
  }

  handleImage = (ev) => {
    const file = ev.target.files[0];
    if (file) {
      const url = window.URL.createObjectURL(file);
      this.setState({ image: url })
    }
  }

  handleChange = (ev) => {
    const target = ev.target;
    this.setState({ [target.name]: target.value })
  }

  handleSubmit = (ev) => {
    ev.preventDefault();
    console.log(this.state);
    // this.props.dispatch(
    //   saveEvent(this.state)
    // )
  }

  render() {
    return (
      <div className="event-form">
        <form className="event-form__form" onSubmit={this.handleSubmit}>
          <h2>Create Event</h2>
          <input className="input" type="text" 
            name="name"
            placeholder="Event Name"
            value={this.state.name}
            onChange={this.handleChange} />
          <textarea className="textarea" 
            name="description"
            placeholder="Description"
            value={this.state.description}
            onChange={this.handleChange} />
          <DateTimePicker className="input" readOnly
            name="datetime"
            value={this.state.datetime}
            handleChange={this.handleChange} />
          <input className="input" type="text" 
            name="location"
            placeholder="Location"
            value={this.state.location}
            onChange={this.handleChange} />
          <input className="input" type="text" 
            name="url"
            placeholder="Ticket URL"
            value={this.state.url}
            onChange={this.handleChange} />
          <label className="file">
            Select image
            <input type="file" 
              name="image"
              onChange={this.handleImage} />
          </label>
          <button className="button" type="submit" onClick={this.props.hideModal}>Save</button>
          {/* <button className="button" type="submit">Save Real</button> */}
        </form>
        <div className="event-form__preview">
          <label>
            <img className="event-form__img" src={this.state.image} alt=""/>
            <input className="input hidden" type="file" onChange={this.handleImage} />
          </label>
        </div>
      </div>
    )
  }
}

export default EventForm
// export default connect()(EventForm)


// WEBPACK FOOTER //
// ./src/components/EventForm.js